import { ContentContainer } from "@/components/ContentContainer";
import MarkdownContent from "@/components/MarkdownContent";
import { getKnowledgebaseEntries, getKnowledgebaseEntry } from "@/lib/api";
import { Button, Grid } from "@mui/material";
import Typography from "@mui/material/Typography";
import Link from "next/link";

export default function WissenswertesDetail({page, knowledgeBaseEntry}) {

  return (
    <ContentContainer
      headline={page.title}
      image={page?.heroimage?.formats?.large?.url}
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h3" component="p" color="common.black" textAlign="center">
            {knowledgeBaseEntry.title}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <MarkdownContent input={knowledgeBaseEntry.content} />
        </Grid>
      </Grid>
      <Grid container justifyContent="center" sx={{mt: 4}}>
        <Grid item xs="auto">
          <Button href="/foerderung/wissenswertes" component={Link} variant="outlined" color="secondary">
            Zurück zur Übersicht
          </Button>
        </Grid>
      </Grid>
    </ContentContainer>
  );
}

export async function getStaticProps(context) {
  const baseUrl = `${process.env.NEXT_PUBLIC_API_URL || "http://localhost:1337"}`;
  const pageResponse = await fetch(`${baseUrl}/page-knowledgebase`);
  const page = await pageResponse.json();

  const knowledgeBaseEntry = await getKnowledgebaseEntry(context.params.slug);

  return {
    props: {
      page,
      knowledgeBaseEntry: knowledgeBaseEntry[0]
    },
    revalidate: parseInt(process.env.SSG_REVALIDATE_TIMEOUT)
  }
}

export async function getStaticPaths() {
  const entries = await getKnowledgebaseEntries();

  // Get the paths we want to pre-render based on posts
  const paths = entries.map((entry) => ({
    params: { slug: entry.slug },
  }))

  // We'll pre-render only these paths at build time.
  // { fallback: 'blocking' } will server-render pages
  // on-demand if the path doesn't exist.
  return { paths, fallback: 'blocking' }
}
